
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/devops",
      function () {
        return require("private-next-pages/devops.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/devops"])
      });
    }
  